import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import roadImage from "../../images/road-image.png";
import roadImageMobile from "../../images/road-image-mobile.png";

const RoadFeatures = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // mobile breakpoint

  return (
    <Box
      sx={{
        textAlign: "center",
        px: { xs: "1rem", md: "4rem" },
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          fontSize: { xs: "1.8rem", md: "2.8rem" },
          mb: "1rem",
          color: "var(--secondary-blue)",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        We Steer Your Pallet and Parcel Shipping Forward
      </Typography>

      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1rem", md: "1.5rem" },
          mb: "2rem",
          color: "text.primary",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        Reliable, cost-effective, and built to keep your business moving
        smoothly.
      </Typography>

      <Box
        component="img"
        src={isMobile ? roadImageMobile : roadImage} // swap image on mobile
        alt="Road Shipping Illustration"
        sx={{
          maxWidth: { xs: "100%", md: "70%" },
          height: "auto",
          mx: "auto",
        }}
      />
    </Box>
  );
};

export default RoadFeatures;
